<template>
    <div>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
        <v-label>Date searching is in UTC, results are shown in your timezone.</v-label>
        <v-spacer></v-spacer>
        <v-data-table
            :headers="headers"
            :items="cdrs.data" :loading="isLoadingCDRS"
            :pagination.sync="options"
            v-on:update:pagination="updateCDRS"
            :total-items="totalRecords"
            :server-items-length="totalRecords"
            :rows-per-page-items="rowsperpageitems">
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded">
                    <td>{{ moment.utc(props.item.datetime).local().format('Y-MM-DD HH:mm') }}</td>
                    <td>{{ moment.duration(props.item.duration, 'seconds').format("h:mm:ss", {trim: false}) }}</td>
                    <td>
                    <span
                        v-if="props.item.origin_number && !props.item.origin_device">{{
                            props.item.origin_number
                        }}</span>
                        <span v-if="props.item.origin_device">
                        <badge :title="props.item.origin_device"
                               type="primary">
                            {{
                                devices.filter((d) => d.name === props.item.origin_device)[0] ? devices.filter((d) => d.name === props.item.origin_device)[0].extensionName : props.item.origin_device
                            }}
                        </badge>
                    </span>
                    </td>
                    <td>
                    <span v-if="props.item.destination_number && props.item.destination_device != [null]">
                                      {{ props.item.destination_number }}

                     </span>
                        <span v-if="props.item.destination_device && props.item.destination_device_type === 'Device'"
                              v-for="(device, index) in props.item.destination_device">
                                <badge :title="device"
                                       class="ml-1"
                                       type="primary">
                                    {{
                                        devices.filter((d) => d.name === device).length > 0 ? devices.filter((d) => d.name === device)[0].extensionName : device
                                    }}
                                </badge>
                        </span>
                    </td>
                    <td>
                        <badge type="success" v-if="props.item.status === 'ANSWERED'">ANSWERED</badge>
                        <badge type="warning" v-if="props.item.status === 'NO ANSWER'">NO ANSWER</badge>
                        <badge type="danger" v-if="props.item.status === 'BUSY'">BUSY</badge>
                        <badge type="danger" v-if="props.item.status === 'FAILED'">FAILED</badge>
                    </td>
                    <td>
                        <badge type="default"
                               v-if="(props.item.origin_number && !props.item.origin_device) && !props.item.internal">
                            INCOMING
                        </badge>
                        <badge type="warning"
                               v-if="(!props.item.origin_number || props.item.origin_device) && !props.item.internal">
                            OUTGOING
                        </badge>
                        <badge type="success" v-if="props.item.internal">INTERNAL</badge>
                    </td>
                    <td>
                        {{ props.item.cost }} {{ currency }}
                    </td>
                    <td>
                        <audio :id="'audio-' +props.item.id" v-if="props.item.recording" preload="none" controls>
                            <source :src="props.item.recording" type="audio/mp3"/>
                        </audio>
                    </td>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <div>
                    <ul class="list-unstyled pl-5 pt-3">
                        <li>Region: {{ props.item.destination }}</li>
                        <li>Rate: {{ props.item.rate }} {{ currency }}</li>
                        <li>Duration: {{
                                moment.duration(props.item.duration, 'seconds').format("h:mm:ss", {
                                    trim:
                                        false
                                })
                            }}
                        </li>
                        <li>Billed Duration: {{
                                moment.duration(props.item.billed_duration, 'seconds').format("h:mm:ss", {trim: false})
                            }}
                        </li>
                    </ul>
                </div>
            </template>
        </v-data-table>
    </div>

</template>

<script>
import Badge from "../../components/Badge";

export default {
    name: "CDRTable",
    components: {
        Badge,
    },
    computed: {
        search: {
            get() {
                return this.debouncedSearch
            },
            set(val) {
                if (this.timeout) clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    this.debouncedSearch = val;
                    this.updateCDRS(this.options);
                }, 500)
            }
        },
        cdrs() {
            return this.$store.getters['cdrs/CDRS'];
        },
        devices() {
            return this.$store.getters['sipdevice/sipdevices'];
        },
        currency() {
            return this.$store.getters['customer/currency']
        },
        isLoadingCDRS() {
            return this.$store.getters['cdrs/isLoading'];
        },
        timezone() {
            return this.$store.getters['customer/timezone'];
        },
    },
    data() {
        return {
            rowsperpageitems: [5, 10, 25, 50, 100, {"text": "All", "value": -1}],
            options: {
                page: 1,
                rowsPerPage: 25,
            },
            propsToSearch: ['datetime', 'duration', 'destination', 'origin_number', 'origin_device', 'destination_number', 'destination_device'],
            debouncedSearch: '',
            totalRecords: 0,
            timeout: null,
            loading: [],
            headers: [
                {
                    text: 'Date',
                    align: 'left',
                    sortable: true,
                    value: 'datetime'
                },
                {text: 'Duration', value: 'duration', sortable: true,},
                {text: 'Origin', value: 'origin_number'},
                {text: 'Destination', value: 'destination_number'},
                {text: 'Status', value: 'status'},
                {text: 'Direction', value: 'origin_number'},
                {text: 'Cost', value: 'cost', sortable: true,},
                {text: 'Recording', value: 'recording', sortable: true,},
            ],
        };
    },
    mounted() {
        if (this.$store.getters['sipdevice/needUpdate']) {
            this.$store.dispatch('sipdevice/loadSIPDevices');
        }
    },
    methods: {
        updateCDRS(options) {
            this.options = options
            this.$store.dispatch('cdrs/loadCDRS', {
                page: options.page,
                search: this.debouncedSearch,
                per_page: options.rowsPerPage,
            });
        },
    },
    watch: {
        cdrs: {
            handler() {
                this.totalRecords = this.cdrs.meta.total;
                document.querySelectorAll('audio').forEach(function (el) {
                    el.load();
                });
            },
            deep: true,
        },
    },
}
</script>
<style>
</style>
